import { useNewControlledWindow } from "hooks/useNewControlledWindow";
import { externalPaths } from "utils/router";

export const useGitHubAppWindow = (
  eventToTrack:
    | "env_setup_devtool_githubapp"
    | "gh_app_install_from_pr_panel"
    | "gh_app_install_from_settings",
) => {
  return useNewControlledWindow({
    url: externalPaths.integrations.githubApp,
    trackEvents: {
      open: eventToTrack,
      close: "gh_app_close_install_popup",
    },
  });
};
